import { transformObjectToCamelCase } from '@utilities';

import axios from './api';

/**
 * create question group
 * @param {Object} options
 * @param {String} options.name
 * @param {Boolean} [options.randomizeOrder]
 * @param {AbortSignal} [options.signal]
 * @return {Promise<{ id: number, name: string, parentGroup: null | number, randomizeOrder: boolean }>}
 */
export const createQuestionGroup = async ({ name, randomizeOrder = false, signal }) => {
  return axios({
    data: {
      name,
      randomize_order: randomizeOrder,
    },
    method: 'post',
    signal,
    url: '/instantsurvey/question_group/',
  }).then(({ data }) => transformObjectToCamelCase(data));
};

/**
 * update question group
 * @param {Object} options
 * @param {Number} options.id
 * @param {String} [options.name]
 * @param {Boolean} [options.randomizeOrder]
 * @param {AbortSignal} [options.signal]
 * @return {Promise<{ id: number, name: string, parentGroup: null | number, randomizeOrder: boolean }>}
 */
export const updateQuestionGroup = async ({ id, name, randomizeOrder, signal }) => {
  const data = {};
  if (name !== undefined) data.name = name;
  if (randomizeOrder !== undefined) data.randomize_order = randomizeOrder;

  return axios({
    data,
    method: 'patch',
    signal,
    url: `/instantsurvey/question_group/${id}/`,
  }).then(({ data }) => transformObjectToCamelCase(data));
};

/**
 * delete question group
 * @param {Object} options
 * @param {Number} options.id
 * @param {AbortSignal} [options.signal]
 * @return {Promise}
 */
export const deleteQuestionGroup = async ({ id, signal }) => {
  return axios({
    method: 'delete',
    signal,
    url: `/instantsurvey/question_group/${id}/`,
  });
};
